// src/pages/admin/EditJob.js
import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import { Breadcrumb } from "../../../components";
import { CardHeader } from "../../../components/cards";
import {Box} from "../../../components/elements";
import PageLayout from "../../../layouts/PageLayout";
import TextField from "@mui/material/TextField";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import { MenuItem } from "@mui/material";
import { Button as MuiButton } from '@mui/material';

export default function EditJob() {
  const { id } = useParams();
  const navigate = useNavigate();
  const token    = localStorage.getItem("token");
  const headers  = { Authorization:`Bearer ${token}` };

  const [job, setJob]       = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BASE_URL}common/jobs/${id}`, { headers })
      .then(({ data }) => setJob(data))
      .catch(console.error)
      .finally(()=>setLoading(false));
  }, [id]);

  const saveJob = async () => {
    if (!job.jobNumber) {
      alert("Job Number is required");
      return;
    }
    try {
      await axios.put(
        `${process.env.REACT_APP_BASE_URL}common/jobs/${id}`,
        job,
        { headers }
      );
      alert("Job updated!");
      navigate("/jobs-list");
    } catch (e) {
      alert(e.response?.data?.message || "Error saving job");
    }
  };

  if (loading || !job) return <PageLayout><p>Loading…</p></PageLayout>;

  return (
    <PageLayout>
      <Grid container spacing={2} className="align-items-center mb-3">
        <Grid size={{ xs: 12, md: 6 }}><Breadcrumb title="Edit Job" /></Grid>
        <Grid size={{ xs: 12, md: 6 }} className="text-end">
          <Link to="/jobs-list">
            <MuiButton variant="contained" color="secondary">Back to List</MuiButton>
          </Link>
        </Grid>
      </Grid>
      <Box className="mc-card">
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 4 }} className="mb-3">
            <CardHeader title="Job Number" />
            <TextField
              fullWidth
              value={job.jobNumber}
              onChange={e=>setJob({...job,jobNumber:e.target.value})}
            />
          </Grid>
          <Grid size={{ xs: 12, md: 8 }} className="mb-3">
            <CardHeader title="Description" />
            <TextField
              fullWidth
              value={job.description||""}
              onChange={e=>setJob({...job,description:e.target.value})}
            />
          </Grid>
          {/* <Grid size={{ xs: 12, md: 4 }} className="mb-3">
            <CardHeader title="Active" />
            <TextField
              select fullWidth
              value={job.active.toString()}
              onChange={e=>setJob({...job,active:e.target.value==="true"})}
            >
              <MenuItem value="true">Active</MenuItem>
              <MenuItem value="false">Inactive</MenuItem>
            </TextField>
          </Grid> */}
        </Grid>
        <Grid container spacing={2} className="mt-3">
          <Grid size={12} className="text-end">
            <MuiButton variant="contained" color="primary" onClick={saveJob}>
              Save Changes
            </MuiButton>
          </Grid>
        </Grid>
      </Box>
    </PageLayout>
);
}
